var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddToDic = function SvgAddToDic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 3.34315 5.34315 2 7 2H20V4H7C6.44772 4 6 4.44772 6 5V6H19C19.5523 6 20 6.44772 20 7V12H18V8H6V20H13V22H5C4.44772 22 4 21.5523 4 21V5Z",
    fill: "#3F7F7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22V19H14V17H17V14H19V17H22V19H19V22H17Z",
    fill: "#3F7F7D"
  })));
};
export { SvgAddToDic as ReactComponent };
export default __webpack_public_path__ + "assets/6c631e95.svg";